export default __webpack_public_path__ + "351cb916a076c2bb41188cd13ac7925c.png";